const list = state => state.list;

export default {
	list,
};
